var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('loading'),_c('v-content',[_c('router-view'),_c('custom-snackbar'),_c('legal-terms-dialog',{attrs:{"isLegalTermsVisible":_vm.isLegalTermsVisible,"mode":"save"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }